import { TabContext, TabList, TabPanel } from "@mui/lab"
import { Box, Button, Grid, Tab, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { ASL_3, ASL_5 } from "../../global/multiAsl";
import { useDispatch, useSelector } from "react-redux";
import { informativaPrivacySelector } from "../../modules/profilazione/selectors";
import { getUltimaInformativaAction } from "../../modules/profilazione/actions";
import { LOADING } from "../../global/statusLabels";

export const PrivacyMultiAsl = () => {

    const [value, setValue] = useState(ASL_3.codice);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const dispatch = useDispatch();
    const ultimaInformativa = useSelector(informativaPrivacySelector);
    const ultimaInformativaPDFASL3 = useSelector(informativaPrivacySelector)?.value?.ASL_3?.pdf
    const ultimaInformativaPDFASL5 = useSelector(informativaPrivacySelector)?.value?.ASL_5?.pdf

    useEffect(() => {

        if (ultimaInformativa?.status !== LOADING && ultimaInformativa?.status !== 200) {
            dispatch(getUltimaInformativaAction());
        }
    }, [dispatch, ultimaInformativa]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const DocumentoPrivacy = ({ ultimaInformativa, asl }) => {
        return (
            <Box sx={{
                textAlign: "center",
                display: "flex",
                margin: "auto",
                width: '100%',
                maxWidth: '1000px'
            }}>

                <object data={`data:application/pdf;base64,${ultimaInformativa}`} width="100%" height="1200px" type="application/pdf" >
                    <p><a href={`data:application/pdf;base64,${ultimaInformativa}`} download="document.pdf">
                        <Button
                            variant="contained"
                            sx={{
                                height: { lg: "50px" },
                                width: { lg: "200px" },
                                backgroundColor: "#005397",
                                borderRadius: "20px !important",
                            }}
                        >
                            Scarica l'informativa
                        </Button>
                    </a></p>
                </object>
            </Box>
        )
    }

    return (
        <>
            <Box sx={{
                flexGrow: 1,
                overflow: 'hidden',
                with: "80%"
            }}>
                <Box sx={{ x: 'auto' }}>

                    <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                        <Typography
                            component='h1'
                            sx={{
                                color: "#005397",
                                margin: "auto",
                                textAlign: "center",
                                fontSize: { xs: "25px", md: "40px" },
                                fontWeight: 700,
                            }}
                        >
                            Privacy policy
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ my: 0, mx: 'auto' }}>

                    <Box
                        sx={{
                            width: "100%",
                            margin: "auto",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <Box sx={{ width: '100%', display: "flex", justifyContent: 'center' }}>
                            <TabContext value={value} >
                                <Box sx={{ display: "flex", justifyContent: 'center', flexDirection: 'column', width: '100%' }}>
                                    <Box sx={{ display: "flex", justifyContent: 'center', }}>
                                        <TabList onChange={handleChange} aria-label="ASL tab">
                                            <Tab label="Asl 3" value={ASL_3.codice} disableRipple sx={{ fontSize: { xs: '16px', md: '30px' }, fontWeight: 600, color: "#005397" }} />
                                            <Tab label="Asl 5" value={ASL_5.codice} disableRipple sx={{ fontSize: { xs: '16px', md: '30px' }, fontWeight: 600, color: "#005397" }} />
                                        </TabList>
                                    </Box>

                                    <TabPanel value={ASL_3.codice}>
                                        <DocumentoPrivacy ultimaInformativa={ultimaInformativaPDFASL3} asl={ASL_3.codice} />

                                    </TabPanel>
                                    <TabPanel value={ASL_5.codice} >
                                        <DocumentoPrivacy ultimaInformativa={ultimaInformativaPDFASL5} asl={ASL_5.codice} />
                                    </TabPanel>

                                </Box>
                            </TabContext>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    )
}